<template>
  <div class="row-item">
    <div class="item-header">
      <button class="button is-text drag">
        <img
          src="@/assets/icons/drag.svg"
          alt="" />
      </button>

      <h3>{{ inputs.name }}</h3>
    </div>

    <div class="tabs">
      <!-- <b-tabs
        type="is-boxed"
        class="is-fullwidth"
        @input="tabSelection">
        <b-tab-item
          v-for="tab in tabs"
          :key="tab"
          :value="tab"
          :label="tab.split('-').join(' ')" />
      </b-tabs> -->

      <Tabs
        v-model="inputSectionTab"
        :tabs="tabs"
        :is-objects="true" />
    </div>

    <div
      v-if="inputSectionTab === 'layout-label'"
      class="">
      <b-field
        label="Display Label"
        class="input-field"
        message="">
        <b-input
          v-model="inputs.name" />
      </b-field>
    </div>

    <div v-if="inputSectionTab === 'measure'">
      <MeasureConfigEditor
        v-model="inputs.measure_config"
        :errors="childErrors('measure_config', errors)"
        :context="{
          reportDimensions: context.pivotDimension ? [ context.pivotDimension, ] : [],
          timeRangeDefaultLabel: 'Use row default',
          timeRangeDefaultName: measureTimeRangeDefaultName,
          defaultMeasureOption: defaultMeasureOption,
          filterModes: true,
          rowFilters: context.parentRowFilters || [],
        }" />
    </div>

    <div v-if="inputSectionTab === 'benchmark'">
      <BenchmarkConfigEditor
        v-model="inputs.comparison_config"
        :errors="childErrors('comparison_config', errors)"
        :context="{
          parentMeasure: benchmarkParentMeasure,
          parentIsPctTotal: benchmarkParentIsPctTotal,
          reportDimensions: context.pivotDimension ? [ context.pivotDimension, ] : [],
          timeRangeDefaultLabel: 'Use measure default',
          timeRangeDefaultName: benchmarkTimeRangeDefaultName,
        }" />
    </div>

    <div v-if="inputSectionTab === 'format'">
      <b-field class="input-field mb-4">
        <b-switch
          v-model="overrideDataFormat"
          type="is-info">
          Override Measure Format
        </b-switch>
      </b-field>
      <DataFormatEditor
        v-if="overrideDataFormat"
        v-model="inputs.data_format"
        :errors="childErrors('data_format', errors)"
        :measure="effectiveMeasure"
        :type-override="formatTypeOverride" />
    </div>
  </div>
</template>

<script>
  import MeasureConfigEditor from '@/components/reports/config/modules/common/MeasureConfigEditor'
  import BenchmarkConfigEditor from '@/components/reports/config/modules/common/BenchmarkConfigEditor'
  import Tabs from '@/components/pdf_report/Tabs.vue'
  import DataFormatEditor from '@/components/reports/config/modules/common/DataFormatEditor'
  import { childErrors as _childErrors } from '@/components/reports/config/common/validation'

  export default {
    name: 'TrackerRowTotal',
    components: {
      MeasureConfigEditor,
      BenchmarkConfigEditor,
      Tabs,
      DataFormatEditor,
    },
    props: {
      value: {
        type: Object,
        default: () => {},
      },
      context: {
        type: Object,
        default: () => {},
      },
      errors: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        rowMeasureOptions: ['CompanyMeasureRef',],
        inputSectionTab: 'layout-label',
      }
    },

    computed: {
      tabs () {
        return [
          {
            label: 'Layout Label',
            id: 'layout-label',
            hasErrors: false,
          },
          {
            label: 'Measure',
            id: 'measure',
            hasErrors: _childErrors('measure_config', this.errors).length > 0,
          },
          {
            label: 'Benchmark',
            id: 'benchmark',
            hasErrors: _childErrors('comparison_config', this.errors).length > 0,
          },
          {
            label: 'Format',
            id: 'format',
            hasErrors: _childErrors('data_format', this.errors).length > 0,
          },
        ]
      },
      inputs: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        },
      },
      measureTimeRangeDefaultName () {
        return this.context.rowMeasureTimeRange?.name || this.context.timeRangeDefaultName || ''
      },
      benchmarkParentMeasure () {
        return this.inputs.measure_config?.measure || this.context.parentRowMeasure || null
      },
      benchmarkParentIsPctTotal () {
        return !!this.inputs.measure_config?.is_pct_total
      },
      benchmarkTimeRangeDefaultName () {
        return this.inputs.measure_config?.time_range?.name || this.context.rowMeasureTimeRange?.name || this.context.timeRangeDefaultName || ''
      },
      defaultMeasureOption () {
        const name = this.context.parentRowMeasure?.name || this.context.parentRowMeasure?.key || ''
        return { name: `Use Row Default (${name || 'None Selected'})`, }
      },
      effectiveMeasure () {
        return this.inputs.measure_config?.measure || this.context.parentRowMeasure || null
      },
      formatTypeOverride () {
        if (this.inputs.measure_config?.is_pct_total) return 'percentage'
        if (this.inputs.comparison_config?.difference_type === 'var') return 'percentage'
        return null
      },
      overrideDataFormat: {
        get () {
          return this.inputs.data_format != null
        },
        set (override) {
          if (override) {
            this.$set(this.inputs, 'data_format', {})
          } else {
            this.$set(this.inputs, 'data_format', null)
          }
        },
      },
    },

    watch: {
      value: {
        handler (cell) {
          if (cell && cell.measure_config == null) {
            this.$set(cell, 'measure_config', { measure: null, })
          }
        },
        immediate: true,
      },
    },

    beforeDestroy () {},

    methods: {
      childErrors: _childErrors,
    },
  }
</script>

<style lang="scss" scoped>
.row-item {
  margin: 10px 0;
  border: $border-1;
  padding: 15px 20px;
  background-color: white;
  border-radius: 10px;

  .item-header {
    display: flex;
    margin-bottom: 20px;
    align-items: center;

    .drag {
      width: 25px;
      height: 25px;
      padding: 0;
      img {
        width: 20px;
      }
    }

    h3 {
      font-size: 15px;
    }

    .delete {
      margin-left: auto;
    }
  }
}

.tabs {
  width: 100%;
}
</style>
